import { useMemo } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { useSelector } from "@jti/store/reduxHooks";
import { selectPrices } from "@jti/store/selectors/selectPrices";

const useCurrentPrice = (isFreeTrial: boolean, isStandardCheckoutFlow: boolean | null, selectedOrderDetails: any) => {
  const { showPricesWithTaxExcluded = false } = useConfig();

  const pricesList = useSelector((state) => selectPrices(state, showPricesWithTaxExcluded));

  const trialCartPrices = useSelector((state) => state.freeTrialCart.prices);

  return useMemo(() => {
    if (isFreeTrial && trialCartPrices.data) {
      return trialCartPrices.data;
    }

    if (!isFreeTrial && isStandardCheckoutFlow === false) {
      return selectedOrderDetails?.prices ?? null;
    }

    if (!isFreeTrial && (isStandardCheckoutFlow || isStandardCheckoutFlow === null)) {
      return pricesList;
    }

    return null;
  }, [isFreeTrial, trialCartPrices.data, isStandardCheckoutFlow, selectedOrderDetails?.prices, pricesList]);
};

export default useCurrentPrice;
